// components/LanguageRedirect.tsx
// Syncs URL language with LanguageContext
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import { getLanguageFromPath, isValidLanguagePath, getEquivalentPath } from '../config/routes';
import type { Language } from '../config/routes';

const LanguageRedirect: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { language, setLanguage } = useLanguage();

  useEffect(() => {
    const pathLang = getLanguageFromPath(location.pathname);

    // If URL has a valid language prefix, sync context to URL
    if (pathLang && pathLang !== language) {
      setLanguage(pathLang);
    }
  }, [location.pathname, language, setLanguage]);

  return null;
};

export default LanguageRedirect;
